module.exports = __webpack_public_path__ + "img/STERiJECT_01.2797d02b.png";